import { render, staticRenderFns } from "./VendaProdutoDialog.vue?vue&type=template&id=1077da08"
import script from "./VendaProdutoDialog.vue?vue&type=script&lang=js"
export * from "./VendaProdutoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports